'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresEventTicketWrapper = function () {
    function WinresEventTicketWrapper() {
        _classCallCheck(this, WinresEventTicketWrapper);
    }

    _createClass(WinresEventTicketWrapper, [{
        key: '$onInit',
        value: function $onInit() {
            // this.destCode = this.winresReservationContext._readUrlPartSkipPrefix(0) || 'TPARC20';
            this.destCode = this.winresReservationContext.Params.DestinationCode || 'TPARC20';
        }
    }]);

    return WinresEventTicketWrapper;
}();

_module3.default.component('winresEventTicketWrapper', {
    template: require('./winresEventTicketWrapper.html'),
    controller: WinresEventTicketWrapper,
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresEventTicketWrapper/winresEventTicketWrapper.js
// module id = 299
// module chunks = 2